module.exports = __webpack_public_path__ + "img/default.4773cf78.svg";